// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ls-0";
export var assigneeDetails = "_ls-1";
export var assigneeInfo = "_ls-2";
export var dropdownContainer = "_ls-4";
export var dropdownImage = "_ls-5";
export var editAssigneeInfo = "_ls-3";
export var editAssigneeModalContainer = "_ls-6";
export var hidden = "_ls-8";
export var input = "_ls-7";